/* eslint-disable jsx-a11y/no-access-key */
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MenuItem, OutlinedInput, Select } from '@material-ui/core'
import { convertLanguagesToShort, useAutoCompleteStyles } from '../../utils'
import { KeyboardArrowDown } from '@material-ui/icons'
import { useSelector } from 'react-redux'
import config from '../../config'
import { useTheme } from '@material-ui/styles'

const BenchmarkSelector = ({
  benchmarkList,
  useBenchmarkList,
  handleOnTextTypeChange,
  accessKey,
  styleMain,
  stylePaper,
  styleArrow,
  ariaLabel,
  labelId
}) => {
  const { t, i18n: { language: i18nLanguage } } = useTranslation()
  const { theme: { colors, bgColors } } = useTheme()
  const shortLanguage = convertLanguagesToShort(i18nLanguage)
  const themeState = useSelector(state => state.userData.theme)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const classes = useAutoCompleteStyles(bgColors, colors)()
  return (

    <Select
      value={useBenchmarkList > -1 ? useBenchmarkList : 0}
      className="font-weight-bold"
      style={styleMain}
      onChange={handleOnTextTypeChange}
      disableUnderline
      IconComponent={props => (
        <KeyboardArrowDown style={styleArrow} {...props} />
      )}
      inputProps={{
        accessKey: accessKey,
        'aria-label': ariaLabel,
        'aria-labelledby': labelId
      }}
      MenuProps={{
        PaperProps: {
          style: stylePaper,
        },
      }}
      input={
        <OutlinedInput
          classes={{ root: isContrast ? classes.outlinedRoot : '' }}
        />
      }
    >
      {
        benchmarkList.map((val, key) => (
          <MenuItem key={key} value={key} style={{ display: 'flex', alignItems: 'center' }}>
            <span
              title={`${val['name'][shortLanguage]}` || key}>{`${t(val['taskName'])}` || key}</span>
          </MenuItem>
        ))
      }
    </Select>

  )
}

export default BenchmarkSelector
